import React from "react";
import { useTheme } from "@mui/material/styles";
import qbotLoader from "../../Assets/netclues-master.png";

export const FullPageLoader = ({ isLoading }) => {
  const theme = useTheme();

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        background: theme.palette.background.default,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={qbotLoader}
        alt="Loading..."
        style={{
          width: "120px",
          height: "120px",
          // animation: "spinLoader 2s linear infinite",
        }}
      />

      {/* Inline keyframes inside component */}
      <style>
        {`
          @keyframes spinLoader {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
